/* ------------------------- External Dependencies -------------------------- */
import { Image } from 'particles'

export default Image



// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Image/index.js